import PropTypes from 'prop-types'
import React from 'react'
import matches from 'lodash/matches'
import reject from 'lodash/reject'
import noop from 'lodash/noop'

import { buildChildId } from '@/checkout-instore-legacy/utils/TestUtils'
import PaymentItem from '@/checkout-instore-legacy/components/Commons/PaymentItem'

import SelectorRadio from './SelectorRadio'

export default function GiftCardSelector(props) {
  const giftCards = props.hideGiftCardsInUse
    ? reject(props.giftCards, matches({ inUse: true }))
    : props.giftCards

  const selected = (option, index) => {
    switch (typeof props.selected) {
      case 'number':
        return props.selected === index
      case 'function':
        return props.selected(option, index)
      default:
        return props.selected === option
    }
  }

  const renderGiftCard = (giftCard, index) => {
    const isSelected = selected(giftCard, index)
    return (
      <div
        key={`option-${index}`}
        className="bb b--black-10 pointer hover-bg-light-silver bg-animate"
      >
        <PaymentItem
          id={buildChildId(['item', giftCard.id], props.id)}
          className={isSelected ? 'bg-light-silver' : ''}
          paymentName={giftCard.caption}
          groupName="giftCardPaymentGroup"
          value={giftCard.balance}
          onClick={() => props.onSelect(giftCard, index, { isSelected })}
        >
          <SelectorRadio
            id={buildChildId(['item-selector', giftCard.id], props.id)}
            label=""
            name={props.id}
            value={props.id}
            onChange={noop}
            checked={isSelected}
          />
        </PaymentItem>
      </div>
    )
  }

  return (
    <div id={props.id}>
      <section>{giftCards.map(renderGiftCard)}</section>
    </div>
  )
}

GiftCardSelector.propTypes = {
  id: PropTypes.string,
  selected: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.object,
    PropTypes.func,
  ]),
  giftCards: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  hideGiftCardsInUse: PropTypes.bool,
}
